<h1>{{header}}</h1>

<p>
    Please report to your local Scania IT Customer Support (contact information 
    can be found here: <a href="https://internal.scania.com/00005/24.html">https://internal.scania.com/00005/24.html</a>) 
    and they will relay the issue to the support team.
</p>

<p>Thanks for your paitence</p>
